import { render } from "./PersonalData.vue?vue&type=template&id=e842948e&scoped=true&ts=true"
import script from "./PersonalData.vue?vue&type=script&lang=ts"
export * from "./PersonalData.vue?vue&type=script&lang=ts"

import "./PersonalData.vue?vue&type=style&index=0&id=e842948e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e842948e"]])

export default __exports__